import { Box, Divider, Grid } from '@mui/material';
import Item from '@mui/material/ListItem';
import { makeStyles } from 'tss-react/mui';

import moment from 'moment';

import { StatusInfo } from '@features/workspace/components/shared/status-info';

import {
  applicationStatusActiveList,
  getApplicationStatusText,
  getFundingReason,
} from '@utils/constants';
import { useId } from 'react';
import { useAppSelector } from '@store/hooks';
import {
  selectAdvances,
  selectFundingApplications,
} from '@features/workspace/store/selectors';
import config from '@/app/configs/config';

const useStyles = makeStyles<any>()({
  header: {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '18px',
  },

  date: {
    color: '#838383',
  },

  productInfo: {
    background: 'rgba(251, 251, 251, 0)',
  },

  productType: {
    color: '#B6B6B6',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '18px',
  },
});

enum FundingApplicationTypes {
  Credit,
  CashAdvance,
}

const FundingTypeNames = ['', '(Cash Advance)'];

export function CustomerProductLulaCredit() {
  const id = useId();

  const { classes } = useStyles(null);

  const fundingApplications = useAppSelector(selectFundingApplications);
  const advances = useAppSelector(selectAdvances);

  const properties: Array<any> = [];

  fundingApplications?.forEach(
    (fundingApplication: any, iFundingApplication: number) => {
      const isActive = fundingApplication.status in applicationStatusActiveList;
      const statusMessage = getApplicationStatusText(fundingApplication);

      let activeMessage = 'Active';

      if (isActive && statusMessage.indexOf('Closed') !== -1) {
        // Use closed instead of active
        activeMessage = statusMessage;
      } else if (!isActive) {
        activeMessage = statusMessage;
      }
      const statusComponent = (
        <StatusInfo showIcon isCompleted={isActive} text={activeMessage} />
      );

      const advance = advances.find(
        (a: any) => a.id === fundingApplication.advanceId
      );

      properties.push({
        header: getFundingReason(fundingApplication),
        type:
          advance !== null && advance !== undefined
            ? FundingApplicationTypes.CashAdvance
            : FundingApplicationTypes.Credit,
        text:
          advance !== null && advance !== undefined
            ? `Advance ID ${advance.id}` // `R ${advance?.totalAdvanceValue?.toFixed(2)}`
            : `Funding ID ${fundingApplication.id}`, // `R ${fundingApplication?.amount?.toFixed(2)}`,
        activeState: isActive,
        date: fundingApplication?.createdDate
          ? moment(fundingApplication?.createdDate).format(config.dateFormat)
          : '',
        component: statusComponent,
      });
    }
  );

  return (
    <>
      {properties.map((item: any, iItem: number) => (
        <Box key={`${id}-${iItem}`}>
          {!!iItem && <Divider />}

          <Grid container mb={0.5} mt={1} spacing={0}>
            <Grid container item className={classes.header} xs={4}>
              <Grid item ml={0}>
                {item?.header}
                {item.type !== null && (
                  <>
                    <br />
                    <Item
                      className={classes.productType}
                      sx={{
                        marginLeft: '-16px',
                        marginRight: '32px',
                        marginTop: '-10px',
                        wordBreak: 'keep-all',
                      }}
                    >
                      {FundingTypeNames[item.type]}
                    </Item>
                  </>
                )}
              </Grid>
            </Grid>
            <Grid item className={classes.header} xs={4}>
              {item?.text}
            </Grid>
            <Grid item alignItems="end" className={classes.header} xs={4}>
              <Box alignItems="center" display="flex" flexDirection="column">
                <Box display="flex">{item?.component}</Box>
                <Box className={classes.date} display="flex">
                  {item?.date && item?.date}
                  {!item?.date && <Item sx={{ height: '0px' }}>&nbsp;</Item>}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      ))}
    </>
  );
}
